var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({class:_vm.computedClasses,style:(_vm.computedStyles)},'div',{ id: _vm.id },false),[_vm._l((_vm.areas),function(area,index){return _c('div',{key:index,style:({
      gridColumn: area.gridColumn,
      gridRow: area.gridRow
    })},[_c('WidgetGroup',{attrs:{"widgets":_vm.childrenSlots[area.name]}})],1)}),_c('WidgetGroup',{attrs:{"widgets":_vm.childrenSlots.default}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }